<template>
  <div class="my-home-content1">
        <Row>
            <Col span="4"></Col>
            <Col span="16">
                <div class="home-content1-car">
                  <template>
                      <Carousel  v-model="value2" loop>
                          <CarouselItem>
                              <div class="demo-carousel">2</div>
                          </CarouselItem>
                          <CarouselItem>
                              <div class="demo-carousel">
                                <div class="content-word-1">
                                  <h2>专业信息化云平台解决方案</h2>
                                  <p>依托实力雄厚且经验丰富的产品团队，架构团队运营和运维团队</p>
                                  <p>为客户提供信息化综合管理平台和服务</p>
                                  <div class="content-icon-1">
                                    <div class="icon icon1">
                                      <img src="../../assets/img/quickbi-quick-bI.png" >
                                      <p>以主机安全为视角</p>
                                    </div >
                                    <div class="icon icon2">
                                      <img src="../../assets/img/quickbi-quick-bI.png" >
                                      <p>以主机安全为视角</p>
                                    </div>
                                    <div class="icon icon3">
                                      <img src="../../assets/img/quickbi-quick-bI.png" >
                                      <p>以主机安全为视角</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="content-img-1">
                                  <img class="flash-img" width="36%" src="../../assets/img/thzx-flash.png" />
                                  <img width="100%" src="../../assets/img/carousel-th-1.png" />
                                </div>
                              </div>
                          </CarouselItem>
                      </Carousel>
                  </template>
                </div>
            </Col>
            <Col span="4"></Col>
        </Row>
<!--        <a href="#twoPage">
          <div style="margin-top: 2rem;">
            <Arrow/>
          </div>
        </a>
        <a name="twoPage"></a> -->
  </div>
</template>

<script>
  import Arrow from '@/pages/components/Arrow'
  export default {
    name: 'HomeContent1',
    components:{Arrow},
    data () {
        return {
            value2: 0
        }
    }
  }

</script>

<style>
    .ivu-carousel-dots-inside{
      margin-top: 1rem;
      display: contents;
 
    }
/*    .ivu-carousel-arrow.left {
      display: none;
    }
    .ivu-carousel-arrow.right{
      display: none;
    } */
    .my-home-content1{

    }
    .content-word-1{
      margin-top: 0.65rem;
      width: 50%;
      float: left;

    }
    .content-word-1 h2{
      color: #FFFFFF;
      font-size: 0.4rem;
      margin-bottom: 0.25rem;
      letter-spacing:0.05rem;
    }
    .content-word-1 p{
      color: #ffffff;
      font-size: 0.1rem;
    }
    .content-img-1{
      width: 50%;
      float: left;
     padding-right: 1rem;
    }
    .content-icon-1{
      margin-top: 0.5rem;
      margin-bottom: 0.75rem;
    }
    .icon{
      float: left;
      text-align: center;
    }
    .icon1,.icon2{
      margin-right: 0.25rem;
    }
    .content-img-1{
      position: relative;
    }

/*    .flash-img{
      position: absolute;
    right: 104px;
    top: -8px;
    } */
    @keyframes bounce-down1 {
     0% {
       opacity: 0;
     }
     100% {
       opacity: 1;
     }
    }
    .flash-img{
      position: absolute;
    right: 1.4rem;
    top: -0.13rem;
      /* opacity: 1; */
      animation: bounce-down1 4s linear infinite;
    }
    .home-content1-car{
      margin-top: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home-content/HomeContent1.vue